import React, { useState } from 'react';
import { LayoutDashboard, ChevronDown } from 'lucide-react';
import './AssetsSidebar.css';

// ─── Sidebar section definitions ─────────────────────────────────────────────
const SIDEBAR_SECTIONS = [
    {
        id: 'setup',
        title: 'SETUP',
        items: [
            { label: 'Sites', view: 'sites', matchKeys: ['Sites', 'sites'] },
            { label: 'Locations', view: 'locations', matchKeys: ['Locations', 'locations'] },
            { label: 'Categories', view: 'categories', matchKeys: ['Categories', 'categories'] },
        ],
    },
    {
        id: 'assets',
        title: 'ASSETS',
        items: [
            { label: 'Asset List', view: 'assets-list', matchKeys: ['Asset List', 'assets-list', 'Assets', 'assets'] },
        ],
    },
];

/**
 * AssetsSidebar
 *
 * Props:
 *   setView    {function}  — app-level navigation function
 *   activeItem {string}    — which item is currently highlighted.
 */
const AssetsSidebar = ({ setView, activeItem, onSubItemClick }) => {
    const [openSections, setOpenSections] = useState({
        setup: true,
        assets: true,
    });

    const toggleSection = (sectionId) => {
        setOpenSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId],
        }));
    };

    const userStr = localStorage.getItem('user');
    let userRole = null;
    try {
        const user = JSON.parse(userStr);
        userRole = user?.role;
    } catch (e) {
        userRole = null;
    }

    const normRole = userRole ? userRole.replace(/[-_ ]/g, '').toLowerCase() : '';
    const showAllSections = normRole !== 'government' && normRole !== 'research';

    const isItemActive = (item) => {
        if (!activeItem) return false;
        if (activeItem === item.label || activeItem === item.view) return true;
        if (item.matchKeys && item.matchKeys.includes(activeItem)) return true;
        return false;
    };

    return (
        <div className="assets-sidebar">
            {/* ── Dashboard link ──── */}
            <div
                className={`assets-sidebar-item${(activeItem === 'dashboard' || activeItem === 'assets-dashboard') ? ' active sidebar-active-highlight' : ''}`}
                onClick={() => setView && setView('assets-dashboard')}
            >
                <LayoutDashboard size={13} />
                Dashboard
            </div>

            {/* ── Nav Sections ──── */}
            {SIDEBAR_SECTIONS.map((section) => {
                // If research or government, only show assets section
                if (!showAllSections && section.id !== 'assets') {
                    return null;
                }

                const isOpen = openSections[section.id] ?? true;

                return (
                    <div key={section.id} className="assets-sidebar-section-wrap">
                        <div
                            className="assets-sidebar-section-title"
                            onClick={() => toggleSection(section.id)}
                        >
                            <span>{section.title}</span>
                            <ChevronDown
                                size={12}
                                className={`assets-sidebar-chevron${isOpen ? ' open' : ''}`}
                            />
                        </div>

                        {isOpen && (
                            <div className="assets-sidebar-items-list">
                                {section.items.map((item) => {
                                    const active = isItemActive(item);
                                    return (
                                        <div
                                            key={item.label}
                                            className={`assets-sidebar-sub-item${active ? ' active' : ''}`}
                                            onClick={() => {
                                                if (onSubItemClick) onSubItemClick(item.label);
                                                setView && setView(item.view);
                                            }}
                                        >
                                            {item.label}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default AssetsSidebar;
